var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.pageTitle } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-row",
            { staticClass: "pb-5 no-gutter" },
            [_c("back-button", { attrs: { returnUrl: _vm.returnUrl } })],
            1
          ),
          _vm._v(" "),
          _c("web-service-configuration-form", {
            attrs: { readonly: !_vm.editMode, mode: _vm.mode },
            model: {
              value: _vm.config,
              callback: function ($$v) {
                _vm.config = $$v
              },
              expression: "config",
            },
          }),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "justify-content-end mt-3 no-gutters" },
            [
              _vm.mode === "create"
                ? _c(
                    "b-button",
                    {
                      attrs: { variant: "primary" },
                      on: { click: _vm.createConfig },
                    },
                    [
                      _c("i", { staticClass: "fa-light fa-save" }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.$t("common.sve")))]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.mode === "details" &&
              _vm.editMode === false &&
              _vm.canEditConfig
                ? _c(
                    "b-button",
                    {
                      staticClass: "mr-3",
                      attrs: { variant: "primary" },
                      on: { click: _vm.editModeActivate },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("common.routing.edit_this_config"))
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.mode === "details" &&
              _vm.editMode === false &&
              _vm.canDeleteConfig
                ? _c(
                    "b-button",
                    {
                      staticClass: "mr-3",
                      attrs: { variant: "primary" },
                      on: { click: _vm.deleteConfig },
                    },
                    [
                      _c("i", { staticClass: "fa-light fa-trash" }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("common.routing.delete_config"))),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.mode === "details" && _vm.editMode === true
                ? _c(
                    "b-button",
                    {
                      attrs: { variant: "primary" },
                      on: { click: _vm.editConfig },
                    },
                    [
                      _c("i", { staticClass: "fa-light fa-save" }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.$t("common.sve")))]),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }